"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const PrivateRoute_1 = __importDefault(require("./PrivateRoute"));
// FIXME Admin route and permissions are not really used in transition.
// chaire-lib cannot really test it. Since it is there for evolution, evolution
// should implement it.
const AdminRoute = (props) => react_1.default.createElement(PrivateRoute_1.default, Object.assign({}, props, { permissions: { all: 'manage' } }));
exports.default = AdminRoute;
//# sourceMappingURL=AdminRoute.js.map